import { MouseEvent } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { ANALYTICS_CONSTANTS, trackAnchorClick } from '../../../utilities/analytics';
import KmxArrowRightFilled from '@kmx/mui-icons/KmxArrowRightFilled';
import { CarouselButtons } from '../../../components/CarouselButtons';
import Box from '@mui/material/Box';

interface IResearchArticlesHeaderProps {
    carouselTitle: string;
}

const handleViewAllClick = (carouselTitle: string) => (e: MouseEvent<HTMLAnchorElement>) => {
    trackAnchorClick({
        clickEvent: e,
        taggingEvent: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
        title: 'see more',
        position: carouselTitle,
        href: '/research',
        page: 'Homepage',
    });
};

export const UFTResearchArticlesHeader = ({ carouselTitle }: IResearchArticlesHeaderProps) => (
    <Stack direction="row" sx={{ justifyContent: { xs: 'start', sm: 'space-between' } }}>
        <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
            <Typography
                component="h2"
                variant="h5"
                sx={{
                    typography: { sm: 'h4' },
                    maxWidth: { md: 660, lg: 900 },
                }}
            >
                {carouselTitle}
            </Typography>
            <IconButton
                color="primary"
                href={'/research'}
                sx={{ display: { xs: 'flex', sm: 'none' } }}
                aria-label="View all"
            >
                <KmxArrowRightFilled />
            </IconButton>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ display: { xs: 'none', sm: 'flex' } }}>
            <Button color="secondary" variant="outlined" href="/research" onClick={handleViewAllClick(carouselTitle)}>
                View all
            </Button>
            <Stack direction="row" sx={{ display: { xs: 'none', lg: 'flex' } }}>
                <CarouselButtons sectionIdPrefix={'research-articles'} ariaText="local cars" />
            </Stack>
        </Stack>
    </Stack>
);

export const ResearchArticlesHeader = ({ carouselTitle }: IResearchArticlesHeaderProps) => (
    <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
        <Typography
            component="h2"
            variant="h5"
            sx={{
                typography: { sm: 'h4' },
                maxWidth: { md: 660, lg: 900 },
            }}
        >
            {carouselTitle}
        </Typography>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <CarouselButtons sectionIdPrefix={'research-articles'} ariaText="local cars" />
        </Box>
    </Stack>
);
